<template>
  <modal :showing="showing" size="large" @closed="$emit('cancelled')">
    <h5 class="t-text-md t-font-semibold t-text-gray-900" slot="title">
      New claim for booking {{ bookingNumber }}
    </h5>

    <form @submit.prevent="submitForm">
      <div class="t-w-full t-min-w-lg t-mt-4">
        <div class="md:t-flex md:t-items-start t-mb-6">
          <div class="md:t-w-1/3">
            <label
              class="t-block t-text-gray-500 t-font-bold md:t-text-right md:t-mb-0 t-pr-4"
            >
              What went wrong?
              <span class="t-text-red-500 t-text-md">*</span>
            </label>
          </div>
          <div class="md:t-w-1/2">
            <div class="md:t-w-3/4">
              <div class="t-ml-5">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    value="Product lost"
                    id="Product lost"
                    v-model="form.problem"
                  />
                  Product missing
                </label>
              </div>

              <div class="t-ml-5">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    value="Product arrived damaged"
                    id="Product arrived damaged"
                    v-model="form.problem"
                  />
                  Product arrived damaged
                </label>
              </div>

              <div class="t-ml-5">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    @click="checkedOtherProblem = !checkedOtherProblem"
                  />
                  Other:
                </label>
              </div>
              <div class="t-ml-5">
                <textarea
                  class="t-appearance-none t-border-2 t-border-gray-200 t-rounded t-w-full t-py-2 t-px-4 t-text-gray-700 t-leading-tight focus:t-outline-none focus:t-bg-white focus:t-border-purple-500"
                  :class="checkedOtherProblem ? 't-bg-gray-200' : 't-bg-white'"
                  id="other-problems"
                  v-model="otherProblem"
                  :disabled="checkedOtherProblem"
                ></textarea>
              </div>
              <div class="t-ml-5">
                <div
                  v-show="errors.has('problem')"
                  style="display:block"
                  class="t-text-red-500 t-text-sm"
                >
                  {{ errors.first("problem") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- How have you communicated the issue -->
      <div class="t-w-full t-min-w-lg t-mt-4">
        <div class="md:t-flex md:t-items-start t-mb-6">
          <div class="md:t-w-1/3">
            <label
              class="t-block t-text-gray-500 t-font-bold md:t-text-right md:t-mb-0 t-pr-4"
            >
              How have you communicated the issue?
              <span class="t-text-red-500 t-text-md">*</span>
            </label>
          </div>
          <div class="md:t-w-1/2">
            <div class="md:t-w-3/4">
              <div class="t-ml-5">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    value="Damage was noted on consignment note"
                    id="Damage was noted on consignment note"
                    v-model="form.problem"
                  />
                  Damage was noted on consignment note
                </label>
              </div>

              <div class="t-ml-5">
                <label class="form-check-label">
                  <input
                    type="checkbox"
                    value="Freighthub was notified within 24 hours"
                    id="Freighthub was notified within 24 hours"
                    v-model="form.problem"
                  />
                  Freighthub was notified within 24 hours
                </label>
              </div>

              <div class="t-ml-5">
                <div
                  v-show="errors.has('problem')"
                  style="display:block"
                  class="t-text-red-500 t-text-sm"
                >
                  {{ errors.first("problem") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- How can we resolve this -->
      <div class="t-w-full t-min-w-lg t-mt-4">
        <div class="md:t-flex md:t-items-start t-mb-6">
          <div class="md:t-w-1/3">
            <label
              class="t-block t-text-gray-500 t-font-bold md:t-text-right md:t-mb-0 t-pr-4"
            >
              How can we resolve this?
              <span class="t-text-red-500 t-text-md">*</span>
            </label>
          </div>
          <div class="md:t-w-1/2">
            <div class="t-ml-5">
              <label class="form-check-label">
                <input
                  type="checkbox"
                  value="Product is usable but note the damage on the carrier's feedback."
                  v-model="form.solution"
                />
                Product is usable but note the damage on the carrier's feedback
              </label>
            </div>

            <div class="t-ml-5">
              <label class="form-check-label">
                <input
                  type="checkbox"
                  value="Make a financial claim against carrier."
                  v-model="form.financialClaim"
                />
                Make a financial claim against carrier<br />
                <span class="t-text-gray-500 t-text-sm">
                  Please note that claim amounts are replacement value which is
                  approximated as 60% of the invoice price to your customer
                  unless evidence of a different replacement value is provided.
                  Please note the maximum claim amount is $1000+GST per booking.
                  If your loss may be greater than this, please lodge a claim
                  with your insurance company for any additional amount.
                </span>
              </label>
            </div>

            <div class="t-ml-5">
              <div class="t-flex">
                <span
                  class="t-appearance-none t-border-2 t-bg-gray-200 t-border-gray-200 t-rounded-l t-py-2 t-px-3 t-text-gray-700 t-leading-tight focus:t-outline-none focus:t-bg-white focus:t-border-purple-500"
                  >$</span
                >
                <input
                  type="text"
                  class="t-w-full t-appearance-none t-border-2 t-border-gray-200 t-rounded-r t-w-full t-py-2 t-px-3 t-text-gray-700 t-leading-tight focus:t-outline-none focus:t-bg-white focus:t-border-purple-500"
                  :class="!form.financialClaim ? 't-bg-gray-200' : 't-bg-white'"
                  v-model="form.claimAmount"
                  placeholder="Claim amount"
                  :disabled="!form.financialClaim"
                />
              </div>
            </div>
            <div class="t-ml-5">
              <div
                v-show="errors.has('amount')"
                style="display:block"
                class="t-text-red-500 t-text-sm"
              >
                {{ errors.first("amount") }}
              </div>
            </div>

            <div class="t-ml-5">
              <label class="form-check-label">
                <input
                  type="checkbox"
                  value="other"
                  @click="checkedOtherSolution = !checkedOtherSolution"
                />
                Other:
              </label>
            </div>

            <div class="t-ml-5">
              <textarea
                class="t-appearance-none t-border-2 t-border-gray-200 t-rounded t-w-full t-py-2 t-px-3 t-text-gray-700 t-leading-tight focus:t-outline-none focus:t-bg-white focus:t-border-purple-500"
                :class="checkedOtherSolution ? 't-bg-gray-200' : 't-bg-white'"
                id="other-solutions"
                v-model="otherSolution"
                :disabled="checkedOtherSolution"
              >
              </textarea>
            </div>

            <div class="t-ml-5">
              <div
                v-show="errors.has('solution')"
                style="display:block"
                class="t-text-red-500 t-text-sm"
              >
                {{ errors.first("solution") }}
              </div>
            </div>

            <div class="t-ml-5">
              <label class="form-check-label">
                <input
                  type="checkbox"
                  value="The receiver must keep the goods available for Freighthub to collect and salvage as much value as possible."
                  v-model="form.keepGoods"
                />
                The receiver must keep the goods available for Freighthub to collect and salvage as much value as possible.
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Photos -->
      <div class="t-w-full t-min-w-lg t-mt-4">
        <div class="md:t-flex md:t-items-start t-mb-6">
          <div class="md:t-w-1/3">
            <label
              class="t-block t-text-gray-500 t-font-bold md:t-text-right md:t-mb-0 t-pr-4"
            >
              Photos
            </label>
          </div>
          <div class="md:t-w-1/2">
            <div class="t-ml-5">
              <label>
                Supporting documents for claim <br />
                <span class="t-text-gray-500 t-text-sm">
                  Please include photos of damaged stock, and a customer invoice
                  showing the price of the damaged stock from which the
                  replacement stock value will be calculated</span
                >
              </label>
              <file-uploader
                :files="form.files"
                @uploaded="fileUploaded($event)"
                @deleted="fileDeleted($event)"
              >
              </file-uploader>
            </div>
          </div>
        </div>
      </div>

      <div class="t-flex t-items-center t-justify-end t-px-8 t-pb-8">
        <button
          @click="$emit('cancelled')"
          type="button"
          class="t-bg-gray-500 hover:t-bg-gray-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-2 t-rounded focus:t-outline-none focus:t-shadow-outline"
          data-dismiss="modal"
        >
          Close
        </button>
        <button
          v-if="!saving && errors.count() > 0"
          v-tooltip:top="[
            '<strong class=\'text-center\'>Please fix the errors above</strong>',
            true
          ]"
          class="t-bg-gray-500 hover:t-bg-gray-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-2 t-rounded focus:t-outline-none focus:t-shadow-outline"
          :disabled="true"
          type="button"
        >
          Submit
        </button>
        <button
          v-else
          :disabled="saving"
          type="submit"
          class="t-bg-green-500 hover:t-bg-green-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-2 t-rounded focus:t-outline-none focus:t-shadow-outline"
        >
          <i v-if="saving" class="fa fa-spinner fa-spin"></i>
          <span v-else>Submit</span>
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import Modal from "../../utils/Modal";
import FileUploader from "../../utils/FileUploader";

export default {
  name: "damage-claims-form",
  components: { Modal, FileUploader },
  props: ["bookingId", "bookingNumber", "showing", "files"],
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      form: {
        problem: [],
        solution: [],
        files: [],
        financialClaim: false,
        claimAmount: null,
        keepGoods: null,
      },
      uploading: false,
      file: null,
      otherProblem: "",
      otherSolution: "",
      checkedOtherProblem: true,
      checkedOtherSolution: true,
      saving: false
    };
  },

  methods: {
    fileUploaded(file) {
      this.form.files.push(file);
    },

    fileDeleted(index) {
      this.form.files.splice(index, 1);
    },

    submitForm() {
      if (!this.checkedOtherProblem) {
        this.form.problem.push(this.otherProblem);
      }

      if (!this.checkedOtherSolution) {
        this.form.solution.push(this.otherSolution);
      }

      if (this.form.keepGoods) {
        this.form.solution.push(`The receiver must keep the goods available for Freighthub to collect and salvage as much value as possible.`);
      }

      if (this.form.financialClaim) {
        if (!this.form.claimAmount) {
          this.errors.add({
            field: "amount",
            msg: "Please enter a dollar amount for your claim"
          });

          return;
        }
        this.form.solution.push(
          "Make a financial claim for $" + this.form.claimAmount
        );
      }

      if (this.form.problem.length === 0) {
        this.errors.add({
          field: "problem",
          msg: "Please select at least one thing that went wrong."
        });

        return;
      }

      if (this.form.solution.length === 0) {
        this.errors.add({
          field: "solution",
          msg: "Please select at least one way we can resolve this for you."
        });

        return;
      }

      this.saving = true;
      let tooltip = document.querySelectorAll(".tooltip");
      for (var index = 0; index < tooltip.length; index++) {
        tooltip[index].style.display = "none";
      }

      console.log("solution", this.form);

      axios
        .post(
          "/send-freight/bookings/" + this.bookingId + "/damage-claims",
          this.form,
          {
            headers: { "content-type": "application/json" }
          }
        )
        .then(response => {
          this.saving = false;
          this.$swal({
            title: "Damage claim submitted",
            type: "success",
            confirmButtonText: "Okay"
          });
          this.$emit("submitted");
        })
        .catch(errors => {
          this.saving = false;
          Event.$emit("serverError");
          this.$emit("cancelled");
        });
    }
  },
  watch: {
    "form.problem": function() {
      if (this.form.problem.length > 0) {
        this.errors.remove("problem");
      }
    },
    "form.solution": function() {
      if (this.form.solution.length === 0) {
        this.errors.remove("solution");
      }
    },
    "form.financialClaim": function(checked) {
      if (checked) {
        this.errors.remove("solution");
      } else {
        this.errors.remove("amount");
      }
    },
    "form.claimAmount": function(newValue) {
      if (newValue) {
        this.errors.remove("amount");
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
